import auStatesPoints from './au/au-states-points.json';
import auStates from './au/au-states.json';
import nzStatesPoints from './nz/nz-states-points.json';
import nzStates from './nz/nz-states.json';

const featureCollection = { type: 'FeatureCollection' };

export const states = {
  ...featureCollection,
  features: [...auStates, ...nzStates],
};

export const statePoints = {
  ...featureCollection,
  features: [...auStatesPoints, ...nzStatesPoints],
};
